<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-08-12 18:58:32
 * @LastEditTime: 2022-03-01 14:21:35
 * @Description: file content
-->
<template>
  <div class="app-wrap">
    <div :span="24" class="padding24 h100 overflow-x-y">
      <!-- 搜索框 -->
      <div class="search" style="height: 60px">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="searchForm.value"
              clearable
              style="width: 316px"
              :placeholder="$t('role.searchPlaceHolder')"
              @keyup.enter.native="handleSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="handleSearch"
              />
            </el-input>
          </el-form-item>

          <!-- 添加角色按钮，同步角色按钮 -->
          <el-form-item class="float-right" style="margin-right: 0">
            <el-button
              v-if="checkPermission(['init_sys_role_addRole'])"
              icon="el-icon-circle-plus-outline"
              type="primary"
              @click="
                handleAddRoleShow({
                  type: 'add',
                  data: null
                })
              "
            >
              {{ $t('role.addRole') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 角色列表-->
      <CustomTable
        ref="customTable"
        :loading="tableLoading"
        :table-data="roleList"
        :pagination="pagination"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column prop="roleName" :label="$t('role.roleName')" />
        <el-table-column prop="roleCode" :label="$t('role.roleCode')" />
        <el-table-column prop="createTime" :label="$t('public.createTime')" />
        <el-table-column :label="$t('public.operation')" width="180">
          <template slot-scope="scope">
            <el-button type="text" class="cursor-p" @click="handleEditRolePermission(scope.row)">
              {{ $t('role.assignMenu') }}
            </el-button>
            <el-button
              v-if="checkPermission(['init_sys_role_edit'])"
              type="text"
              class="cursor-p"
              @click="
                handleAddRoleShow({
                  type: 'edit',
                  data: scope.row
                })
              "
            >
              {{ $t('common.edit') }}
            </el-button>
            <el-button
              v-if="checkPermission(['init_sys_role_delete'])"
              type="text"
              class="cursor-p"
              style="color: red"
              @click="handleDelete(scope.row)"
            >
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </CustomTable>
    </div>

    <!-- 添加编辑角色 -->
    <role-detail
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      :content="userDetailDialogContent"
      :loading.sync="dialogLoading"
      @confirm="editRoleCallback($event)"
    />
    <!-- 编辑角色菜单 -->
    <assign-menu
      v-if="editMenuVisible"
      :visible.sync="editMenuVisible"
      :loading.sync="dialogLoading"
      :role-id="assignRoleId"
      :role-name="assignRoleName"
      :web-menu-tree="webMenuTree"
      :app-menu-tree="appMenuTree"
      :parent-nodes="partentNodes"
      @confirm="assignMenuCallback($event)"
    />

    <!-- 角色关联用户 -->
    <assign-user
      v-if="editUserVisible"
      :visible.sync="editUserVisible"
      :loading.sync="dialogLoading"
      :role-id="assignRoleId"
      :role-name="assignRoleName"
      :org-tree="orgTree"
      @confirm="assignUserCallback($event)"
    />
    <!-- 删除 -->
    <delete-dialog
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleConfirmDelete"
    />
  </div>
</template>

<script>
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import RoleDetail from "./components/role-detail";
import AssignMenu from "@/views/standard/role/components/role-assign-menu.vue";
import AssignUser from "@/views/standard/role/components/role-assign-user.vue";
import role_api from "@/api/role/role";
import user_api from "@/api/user/user";
import BusinessApi from "@/api/business";
import { mapGetters } from "vuex";

export default {
  name: "RoleListInit",
  components: {
    RoleDetail,
    AssignMenu,
    AssignUser,
    DeleteDialog
  },
  computed: {
    ...mapGetters(["tenantId", "isSystem"])
  },
  data() {
    return {
      searchForm: {
        value: ""
      },
      // 新增或者编辑角色
      addDialogVisible: false,
      userDetailDialogContent: { title: "新增角色" },
      dialogLoading: false,

      /**
       * 角色菜单权限相关
       *
       */
      // 是否显示编辑角色菜单弹窗
      editMenuVisible: false,
      // 全量的菜单
      webMenuTree: [],
      appMenuTree: [],
      // 有子菜单的id数组
      partentNodes: [],

      // 要编辑的用户
      assignRoleId: "",
      // 要编辑的角色名称
      assignRoleName: "",

      /**
       * 角色关联用户相关
       *
       */
      // 是否显示角色关联用户弹窗
      editUserVisible: false,
      // 组织树
      orgTree: [],

      loading: false,
      beforeEditVisible: false,

      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableLoading: false,
      roleList: [],
      dicTableData: [{}],
      viewDicTableData: [],
      currentPage: 1,
      dialogViewVisible: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteId: "",
      dialogVisible: false,
      operType: "add",
      dialogData: {},
      dialogViewData: {},
      deleteContent: {
        title: "确定要删除此角色吗",
        description: "删除后不可恢复,请谨慎操作"
      }
    };
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    this.getRoleList();
    this.getMenuTree();
    // 非管理员才去获取组织树 & 用户列表
    if (!this.isSystem) {
      this.getOrgTree();
      this.getUserList();
    }
  },
  methods: {
    /**
     * @description: 查询角色列表
     * @param {*}
     * @return {*}
     */
    getRoleList() {
      this.roleList = [];
      // this.searchForm.value = "";
      role_api
        .getRoleList({
          search: this.searchForm.value,
          size: this.pagination.pageSize,
          page: this.pagination.pageNum
        })
        .then(res => {
          if (res && res.data) {
            this.roleList = [];
            this.pagination.total = Number(res.data.total);
            res.data.records.forEach(element => {
              element.userNum = element.userIds ? element.userIds.length : 0;
              this.roleList.push(element);
            });
          }
        });
    },

    /**
     * @description: 获取用户列表
     * @param {*}
     * @return {*}
     */
    getUserList(orgID) {
      // this.searchForm.value = "";
      user_api.getOrgAllUser().then(res => {});
    },

    /**
     * @description: 把用户初始化到组织树,数据很多的时候计算量会很大，需要进一步优化
     * @param {*}
     * @return {*}
     */
    initTreeAndUser() {
      if (this.roleList.length && this.orgTree.length) {
        /*
         *  let newarr=stu.filter(function(item,index,arr0){//调用filter方法，传入函数，若函数返回值为真，则返回该项
         *     // console.log(index);
         *     return item.js>60;//当每项元素的元素的js成绩大于60时返回真
         * });
         */
      }
    },

    /**
     * @description:替换树的userIds为user
     * @param {*}
     * @return {*}
     */
    replaceUserids() {},

    /**
     * @description: 获取菜单树
     * @param {*}
     * @return {*}
     */
    getMenuTree() {
      this.loading = true;
      BusinessApi.getMenuByTenantId(this.tenantId, { parseToTree: true }).then(res => {
        this.loading = false;
        const { data } = res;
        this.webMenuTree = [
          {
            label: "WEB",
            type: "目录",
            id: "-1"
          }
        ];
        this.appMenuTree = [
          {
            label: "APP",
            type: "目录",
            id: "-2"
          }
        ];
        this.partentNodes = [];
        const menuTree = this.handleData(data);
        const web = [];
        const app = [];

        menuTree.forEach(element => {
          if (element.clientType === "WEB") {
            web.push(element);
          } else {
            app.push(element);
          }
        });
        this.webMenuTree[0].children = web;
        this.appMenuTree[0].children = app;
      });
    },

    /**
     * @description:
     * @param {*} isFirst
     * @return {*}
     */
    getOrgTree() {
      const parmas = {
        parseToTree: true,
        withUser: true
      };
      user_api.getOrgList(this.tenantId, parmas).then(res => {
        const { data } = res || {};
        this.orgTree = [data];
      });
    },

    /**
     * @description: // 格式化菜单tree
     * @param {*} data
     * @param {*} level
     * @return {*}
     */
    handleData(data) {
      return data.map(o => {
        const typeText = o.menuType === "MENU" ? "菜单" : o.menuType === "BUTTON" ? "按钮" : "目录";
        const obj = {
          type: typeText,
          label: o.menuName,
          clientType: o.clientType,
          id: o.id
        };
        if (o.children && o.children.length) {
          this.partentNodes.push(o.id);
          obj.children = this.handleData(o.children);
        }
        return obj;
      });
    },

    /**
     * @description: 新增或者编辑角色
     * @param {*} data {
     *        type: ”add“--新增， ”edit“--编辑，
     *        data:type为edit才会有值，为编辑的角色数据
     *                  }
     * @return {*}
     */
    handleAddRoleShow(data) {
      this.addDialogVisible = true;
      this.dialogLoading = false;
      this.userDetailDialogContent = {
        title: data.type === "add" ? "新增角色" : "编辑角色",
        type: data.type,
        formData: data.data
      };
    },

    /**
     * @description:角色关联用户
     * @param {*} data，用户数据
     * @return {*}
     */
    handleEditRoleUser(data) {
      this.assignRoleId = data.id;
      this.assignRoleName = data.roleName;
      this.editUserVisible = true;
    },

    /**
     * @description:编辑用户权限
     * @param {*} data，用户数据
     * @return {*}
     */
    handleEditRolePermission(data) {
      this.assignRoleId = data.id;
      this.assignRoleName = data.roleName;
      this.editMenuVisible = true;
    },

    /**
     * @description: 添加角色完成
     * @param {*} result
     * @return {*}
     */
    editRoleCallback(result) {
      const { data } = result;
      this.dialogLoading = true;
      if (result.type === "add") {
        role_api
          .addRole(data)
          .then(res => {
            this.dialogLoading = false;
            this.addDialogVisible = false;
            this.getRoleList();
          })
          .catch(() => {
            this.deleteLoading = false;
          });
      } else if (result.type === "edit") {
        role_api
          .editRole(data)
          .then(res => {
            this.addDialogVisible = false;
            this.dialogLoading = false;
            this.getRoleList();
          })
          .catch(() => {
            this.deleteLoading = false;
          });
      }
    },

    /**
     * @description: 编辑用户菜单完成
     * @param {*} result
     * @return {*}
     */
    assignMenuCallback(result) {
      const { data } = result;
      this.dialogLoading = true;
      if (result.type === "add") {
        role_api
          .addRole(data)
          .then(res => {
            this.dialogLoading = false;
            this.addDialogVisible = false;
            this.getRoleList();
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      } else if (result.type === "edit") {
        role_api
          .editRole(data)
          .then(res => {
            this.dialogLoading = false;
            this.addDialogVisible = false;
            this.getRoleList();
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      }
    },
    // 数据删除包含级联子项删除
    handleDelete(item) {
      this.deleteId = item.id;
      this.deleteLoading = false;
      this.deleteContent.title = `确定要删除"${item.roleName}"角色吗？`;
      this.deleteDialogVisible = true;
    },

    // 删除
    handleConfirmDelete() {
      this.deleteLoading = true;
      role_api
        .deleteRole(this.deleteId)
        .then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.$message.closeAll();
          this.$message.success(this.$t("public.successfullyDeleted"));
          this.getRoleList();
        })
        .catch(() => {
          this.deleteLoading = false;
        });
    },

    /**
     * @description:同步角色
     * @param {*}
     * @return {*}
     */
    handleSyncRole() {},
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.pagination.total = 0;
      this.getRoleList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getRoleList();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.getRoleList();
    },

    isSysFormatter(row) {
      return this.isSysTrans(row.dictPermission);
    },
    isSysTrans(type) {
      for (let i = 0; i < this.isSystemEnum.length; i++) {
        if (this.isSystemEnum[i].id === type) {
          return this.isSystemEnum[i].label;
        }
      }
    },
    dictStatusFormatter(row) {
      return this.dictStatusTrans(row.dictStatus);
    },
    dictStatusTrans(type) {
      for (let i = 0; i < this.dictStatusEnum.length; i++) {
        if (this.dictStatusEnum[i].id === type) {
          return this.dictStatusEnum[i].label;
        }
      }
    },
    // 级联子表是否系统格式化
    caseCadeIsSystemFormate(row) {
      return this.caseCadeIsSystemTrans(row.systemDefault);
    },
    caseCadeIsSystemTrans(type) {
      for (let i = 0; i < this.isSystemCaseEnum.length; i++) {
        if (this.isSystemCaseEnum[i].id === type) {
          return this.isSystemCaseEnum[i].label;
        }
      }
    },

    viewDialogClosed() {
      this.viewFrom = {};
      this.viewDicTableData = [];
    },
    saveSuccess() {
      this.startSearch();
    }
  }
};
</script>

<style scoped>
.padding24 {
  padding: 24px 24px 0;
}

.colorRed {
  color: red;
}

::v-deep .scim-common-theme .self-dialog-form .el-dialog__body {
  overflow-y: hidden !important;
}
</style>
